var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from 'vue-property-decorator';
import HeaderControl from "@/common/components/HeaderControl.vue";
import TextAreaRow from '@/common/components/TextAreaRow.vue';
import TargetGroupControl from "@/template/components/continuousReport/controls/TargetGroupControl.vue";
import AddTargetGroupDialogRow from '@/template/components/continuousReport/controls/AddTargetGroupDialogRow.vue';
import { Notification } from "@/common/services/notificationService";
import ContinuousReportBase from './ContinuousReportBase';
import PeriodSelector from '@/template/components/continuousReport/controls/PeriodSelectorControl.vue';
import _ from 'lodash';
import { isNullOrUndefined } from 'util';
var TargetGroupsAndOperationView = /** @class */ (function (_super) {
    __extends(TargetGroupsAndOperationView, _super);
    function TargetGroupsAndOperationView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TargetGroupsAndOperationView.prototype.mounted = function () {
        this.focusOnFirstTag("h1");
    };
    Object.defineProperty(TargetGroupsAndOperationView.prototype, "model", {
        get: function () {
            return this.sectionModel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TargetGroupsAndOperationView.prototype, "currentPeriodItem", {
        get: function () {
            return this.currentSectionPeriodItem;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TargetGroupsAndOperationView.prototype, "activeMonthData", {
        get: function () {
            var _this = this;
            if (this.currentMonthId !== null) {
                return this.currentPeriodItem.details.find(function (x) { return x.month == _this.currentMonthId; });
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    TargetGroupsAndOperationView.prototype.initCurrentPeriod = function (currentPeriod) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.handleReadonly(currentPeriod);
                this.currentPeriodId = currentPeriod.continuousReportPeriodId;
                this.currentMonthId = currentPeriod.continuousReportPeriod.months[0];
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(TargetGroupsAndOperationView.prototype, "areOpenPeriodsInitialized", {
        get: function () {
            return !this.model.some(function (x) { return x.isOpen && x.details.some(function (x) { return x.items.length == 0; }); });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TargetGroupsAndOperationView.prototype, "targets", {
        get: function () {
            return this.currentPeriodItem.targets;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TargetGroupsAndOperationView.prototype, "targetGroups", {
        get: function () {
            return this.activeMonthData.items;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Delete targetGroup from the list.
     * @param key Key of the targetGroup to remove.
     */
    TargetGroupsAndOperationView.prototype.deleteTargetGroup = function (targetGroup) {
        return __awaiter(this, void 0, void 0, function () {
            var index;
            return __generator(this, function (_a) {
                if (confirm(this.$i18n.t("ContinuousReport.Confirm.TargetGroup").toString())) {
                    index = this.targetGroups.indexOf(targetGroup);
                    this.targetGroups.splice(index, 1);
                    this.forceSave();
                }
                return [2 /*return*/];
            });
        });
    };
    Object.defineProperty(TargetGroupsAndOperationView.prototype, "availableTargetGroupOptions", {
        /**
         * Returns user defined target group options which have not yet been added to the existing period.
         **/
        get: function () {
            return this.targetGroupOptions
                .filter(this.isUserDefinedTargetGroup)
                .filter(this.isNotYetAdded);
        },
        enumerable: false,
        configurable: true
    });
    TargetGroupsAndOperationView.prototype.isUserDefinedTargetGroup = function (group) {
        return group.id < 0;
    };
    TargetGroupsAndOperationView.prototype.isNotYetAdded = function (group) {
        return !this.targetGroups.some(function (g) { return g.name.toLowerCase() == group.name.toLowerCase(); });
    };
    TargetGroupsAndOperationView.prototype.initSelected = function (selected) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.create(selected.name);
                return [2 /*return*/];
            });
        });
    };
    TargetGroupsAndOperationView.prototype.initAdded = function (addedName) {
        return __awaiter(this, void 0, void 0, function () {
            var msg, newMinId, added, e_1, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!this.targetGroupAlreadyExists(addedName)) return [3 /*break*/, 1];
                        msg = this.$t("ContinuousReport.Notification.TargetGroupAlreadyExists").toString();
                        Notification.error(this, msg);
                        return [3 /*break*/, 3];
                    case 1:
                        newMinId = this.newMinId();
                        added = { id: newMinId, name: addedName };
                        return [4 /*yield*/, this.entityService.addTargetGroup(added, this.recordId)];
                    case 2:
                        _a.sent();
                        this.create(added.name);
                        this.targetGroupOptions.push(added);
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        error = "Error adding target group";
                        Notification.error(this, error);
                        console.error(error, e_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    TargetGroupsAndOperationView.prototype.targetGroupAlreadyExists = function (name) {
        return this.targetGroupOptions.some(function (group) { return group.name.toLowerCase() == name.toLowerCase(); });
    };
    TargetGroupsAndOperationView.prototype.newMinId = function () {
        var minId;
        if (this.targetGroupOptions.length > 0) {
            minId = _.minBy(this.targetGroupOptions, function (target) { return target.id; }).id;
        }
        else {
            minId = 0;
        }
        return Math.min(0, minId) - 1;
    };
    TargetGroupsAndOperationView.prototype.create = function (targetGroupName) {
        var _this = this;
        var targetGroup = {
            name: targetGroupName,
            isManuallyAdded: true,
            targetsGroupAndOperationDetails: [{
                    operationType: null,
                    description: null,
                    targets: [],
                    operationCount: null,
                    collectionMethod: null,
                    encounterCount: null,
                    callAttempts: null,
                    hasAgeGenderDistribution: null,
                    ageGenderDistribution: null,
                    peopleTurnover: null
                }]
        };
        this.targetGroups.push(targetGroup);
        this.forceSave();
        this.$nextTick().then(function () {
            var targetId = "targetgroup-" + (_this.targetGroups.length - 1);
            _this.focusOnComponentId(targetId);
        });
    };
    Object.defineProperty(TargetGroupsAndOperationView.prototype, "periods", {
        get: function () {
            var results = [];
            var nPeriods = this.model.length;
            for (var i = 0; i < nPeriods; i++) {
                var periodModel = this.model[i];
                var nDetails = periodModel.details.length;
                for (var j = 0; j < nDetails; j++) {
                    var monthModel = periodModel.details[j];
                    if (monthModel.month < this.currentMonthId)
                        results.push({
                            name: this.$t("Months." + monthModel.month).toString(),
                            data: monthModel
                        });
                }
            }
            return results;
        },
        enumerable: false,
        configurable: true
    });
    TargetGroupsAndOperationView.prototype.initWithSelected = function (data) {
        if (this.hasMonthChanged(this.activeMonthData)) {
            var source = this.$t("Months." + data.month).toString().toLowerCase();
            var target = this.$t("Months." + this.activeMonthData.month).toString().toLowerCase();
            ;
            if (!confirm(this.$i18n.t("ContinuousReport.Confirm.TargetGroupCopy01", [target, source]).toString())) {
                return;
            }
        }
        this.activeMonthData.items = this.createCopy(data.items);
        this.forceSave();
    };
    TargetGroupsAndOperationView.prototype.hasMonthChanged = function (month) {
        var _this = this;
        return month.items.some(function (group) { return _this.hasGroupChanged(group); });
    };
    TargetGroupsAndOperationView.prototype.hasGroupChanged = function (group) {
        var _this = this;
        return !isNullOrUndefined(group.councelingDescription)
            || group.isManuallyAdded == true
            || !isNullOrUndefined(group.isOrganisation)
            || group.targetsGroupAndOperationDetails.some(function (detail) { return _this.hasGroupDetailChanged(detail); });
    };
    TargetGroupsAndOperationView.prototype.hasGroupDetailChanged = function (detail) {
        return !isNullOrUndefined(detail.ageGenderDistribution)
            || !isNullOrUndefined(detail.collectionMethod)
            || !isNullOrUndefined(detail.description)
            || !isNullOrUndefined(detail.encounterCount)
            || !isNullOrUndefined(detail.hasAgeGenderDistribution)
            || !isNullOrUndefined(detail.operationCount)
            || !isNullOrUndefined(detail.operationType)
            || !isNullOrUndefined(detail.peopleTurnover)
            || !isNullOrUndefined(detail.realizedCount)
            || (!isNullOrUndefined(detail.targets) && detail.targets.length > 0);
    };
    TargetGroupsAndOperationView.prototype.createCopy = function (groups) {
        var copy = JSON.parse(JSON.stringify(groups));
        this.prepareCopy(copy);
        return copy;
    };
    TargetGroupsAndOperationView.prototype.prepareCopy = function (groups) {
        var len = groups.length;
        for (var i = 0; i < len; i++) {
            var group = groups[i];
            group.councelingDescription = null;
            var nDetails = group.targetsGroupAndOperationDetails.length;
            for (var j = 0; j < nDetails; j++) {
                var detail = group.targetsGroupAndOperationDetails[j];
                detail.ageGenderDistribution = null;
                detail.collectionMethod = null;
                //toiminnan kuvaus
                //detail.description
                detail.encounterCount = null;
                detail.hasAgeGenderDistribution = null;
                detail.operationCount = null;
                //toimintamuoto
                //detail.operationType 
                detail.peopleTurnover = null;
                detail.realizedCount = null;
                //tavoitteet
                //detail.targets
            }
        }
    };
    TargetGroupsAndOperationView = __decorate([
        Component({
            name: "TargetGroupsAndOperationView",
            components: {
                HeaderControl: HeaderControl,
                TargetGroupControl: TargetGroupControl,
                AddTargetGroupDialogRow: AddTargetGroupDialogRow,
                PeriodSelector: PeriodSelector,
                TextAreaRow: TextAreaRow
            }
        })
    ], TargetGroupsAndOperationView);
    return TargetGroupsAndOperationView;
}(ContinuousReportBase));
export default TargetGroupsAndOperationView;
